import { ITheme } from "./theme.type";
import { theme } from "./theme";

export const LightTheme: ITheme = { ...theme };
